import { render, staticRenderFns } from "./MaybeSvg.vue?vue&type=template&id=323a09c7&"
import script from "./MaybeSvg.vue?vue&type=script&lang=ts&"
export * from "./MaybeSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports